export default __webpack_public_path__ + "static/blog1-02eec7bec51ad5371be0ece4f2f08d96.jpg";